var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('GenericPage',{staticClass:"mb--50"},[_c('template',{slot:"breadcrumb-items"},[_c('li',{staticClass:"active bold"},[_vm._v("Cookies.")])]),_c('template',{slot:"title"},[_vm._v(" Política de Cookies en la Red. ")]),_c('template',{slot:"body"},[_c('PoliticaCookies')],1)],2),_c('LightBanner')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }